import { useGeneralTasksStore } from './useGeneralTasksStore';
import { isTaskAccepted } from '../utils/generalTasksUtils';


export const useIsUploadLocked = (documentStatus?: string) => {
  const { generalTasksStore } = useGeneralTasksStore();

  if (generalTasksStore?.globalStore?.isInternalPortal) {
    return false;
  }

  const taskStatus = generalTasksStore?.editTaskStore?.taskV2?.status;

  return isTaskAccepted(taskStatus) || isTaskAccepted(documentStatus);
};
